<template>
  <div id="app">
    <div class="container-wrapper colored-navbar-brand">
      <nav-bar/>
      <router-view/>
      <footer-temp/>
    </div>
    <div id="back-to-top">
      <a href="#"><i class="ion-ios-arrow-up"></i></a>
    </div>
  </div>
</template>
<script>
  import navBar from './components/general/navbar'
  import footerTemp from './components/general/footerTemp'

  export default {
    components: {navBar, footerTemp}
  }

</script>
<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
<style src="./assets/css/animate.css"/>
<style src="./assets/css/main.css"/>
<style src="./assets/css/component.css"/>
<style src="./assets/css/style.css"/>
